var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.15,
    height: 35,
    viewBox: "0 0 45.15 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.575,5A22.575,22.575,0,0,0,5.025,38.863a2.265,2.265,0,1,0,3.928-2.258,17.88,17.88,0,0,1-2.438-9.03,18.06,18.06,0,1,1,33.705,9.03,2.256,2.256,0,1,0,3.906,2.258A22.575,22.575,0,0,0,24.575,5Zm6.411,13-3.5,3.477a6.569,6.569,0,0,0-2.912-.677,6.773,6.773,0,0,0,0,13.545,6.86,6.86,0,0,0,4.559-1.764,6.661,6.661,0,0,0,2.214-5.009,6.547,6.547,0,0,0-.677-2.89l3.5-3.477A2.259,2.259,0,1,0,30.986,18ZM24.575,29.833a2.267,2.267,0,1,1,2.258-2.258A2.258,2.258,0,0,1,24.575,29.833Z",
    transform: "translate(-2 -5)",
    fill: "#0533b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.088fa85988681191e62b9645fb7d4a64.svg";
export { ForwardRef as ReactComponent };